var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_vm._v("尊敬的会员您好，若要下分，请在牌局结束后返回大厅再进行下分操作。")])}
var staticRenderFns = []

export { render, staticRenderFns }